import script from "./ErrorList.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorList.vue?vue&type=script&setup=true&lang=js"

import "./ErrorList.vue?vue&type=style&index=0&id=7ae6eabb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ae6eabb"]])

export default __exports__